export default {"src":"/_next/static/media/plus.242f4367.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};